import React from 'react';
import { motion } from 'framer-motion';
import { config } from '../config/config';

const Services = () => {
  return (
    <section className="services" id="services">
      <motion.p
        className="sec-label"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        What We Offer
      </motion.p>
      <motion.h2
        className="sec-title"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.1 }}
      >
        OUR <span>SERVICES</span>
      </motion.h2>
      <div className="srv-grid">
        {config.services.map((service, idx) => (
          <motion.div
            key={service.id}
            className="srv-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: idx * 0.1 }}
          >
            <div className="srv-ico">{service.icon}</div>
            <div className="srv-name">{service.name}</div>
            <p className="srv-desc">{service.description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Services;
